var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-right": "10px", display: "inline-block" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.grossMarginText || 0.0) +
              " " +
              _vm._s(_vm.showB ? "%" : "") +
              " "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }